import type { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useZeventTileStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.customPalette.white,
      color: theme.customPalette.black,
      marginRight: theme.spacing(),
    },
    event: {
      border: 'none',
      textAlign: 'left',
      padding: 0,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    eventHeading: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      fontFamily: 'Montserrat, sans-serif',
    },
  })
);
